export default __webpack_public_path__ + "static/media/views_bottom.ff708af5.svg";